export default __webpack_public_path__ + "dist/media/Safe.0a49659e.png";